import propTypes from "prop-types";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { FormDropDown, FormTextInput } from "../core";

export const UpdateModal = ({
  isOpen,
  onClose,
  onSubmit,
  initialData,
  fields,
  header,
}) => {
  const [inputData, setInputData] = React.useState(initialData || {});

  const {
    control,
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const userInfo = useSelector((state) => state.user?.profile);

  useEffect(() => {
    if (initialData) {
      let updatedData;
      if (initialData.role) {
        updatedData = {
          name: initialData?.name,
          isId: initialData?.isId,
          role: { value: initialData.role, label: initialData.role },
        };
      } else {
        updatedData = {
          name: initialData?.name,
        };
      }
      setInputData(updatedData);

      reset(updatedData);
    }
  }, [initialData, reset]);
  const handleChange = (e) => {
    setInputData({ ...inputData, [e.target.name]: e.target.value });
    const { name, value } = e.target;
    setValue(name, value);
  };

  const handleForm = (data) => {
    if (data.role) data.role = data.role.value;
    onSubmit(data);
    onClose();
  };

  const replaceUnderscores = (inputObj) => {
    const newObj = {};
    if (inputObj) {
      Object.keys(inputObj).forEach((key) => {
        newObj[key] = inputObj[key].replace(/_/g, " ");
      });
      return newObj;
    } else {
      return inputObj;
    }
  };

  return (
    isOpen && (
      <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-lg w-1/4">
          <h2 className="text-xl font-semibold mb-4">{header}</h2>
          <form onSubmit={handleSubmit(handleForm)}>
            {fields.map((field, index) => {
              return (
                <>
                  {field.name !== "role" ? (
                    <FormTextInput
                      {...register(field.name, {
                        required: `This field is required`,
                      })}
                      id={field.label}
                      error={errors.name}
                      key={`${field.name}-${index + 1}`}
                      labelName={field.label}
                      value={inputData[field.name]}
                      onChange={handleChange}
                    />
                  ) : (
                    <Controller
                      control={control}
                      name={field.name}
                      key={`${field.name}-${index + 1}`}
                      render={({ field: { onChange, value } }) => (
                        <FormDropDown
                          labelName={field.label}
                          id={field.name}
                          options={
                            userInfo.role === "Super_Admin"
                              ? ["Read", "Admin", "Super Admin"]
                              : ["Read", "Admin"]
                          }
                          onChange={onChange}
                          value={replaceUnderscores(value)}
                        />
                      )}
                    />
                  )}
                </>
              );
            })}
            <div className="flex justify-between">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 bg-teal-600 hover:bg-teal-700"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-sky-800 text-white hover:bg-sky-900"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  );
};

UpdateModal.propTypes = {
  isOpen: propTypes.bool.isRequired,
  onClose: propTypes.func,
  initialData: propTypes.object,
  onSubmit: propTypes.func,
  fields: propTypes.array,
  header: propTypes.string,
  data: propTypes.object,
};
